import React, { useState, useEffect } from "react";
import { BrowserRouter, Route, Redirect, Link, Switch } from "react-router-dom";
import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Home from "./components/home";
import Gallery from "./components/gallery";
import Evaluate from "./components/evaluate";
import Order from "./components/order";
import Print from "./components/print";
import Blob from "./components/blob";
import ScrollRestore from "./components/scrollRestore";
import BodyBase from "./components/body";
import TurnAroundTimes from "./components/turnAroundTimes";
import PayPal from "./components/paypal";
import TermsAndConditions from "./components/termsAndConditions";
import Vacation from "./components/vacation";

import "./index.css";
import "typeface-roboto";

const appBarHeight = 65;
const footerHeight = 50;
const Body = BodyBase(appBarHeight, footerHeight);

const useStyles = makeStyles(() => ({
  appBar: {
    height: appBarHeight,
    paddingLeft: 24,
  },
  link: {
    color: "inherit",
    textDecoration: "none",
    display: "block",
    width: "100%",
  },
  appBarImage: {
    height: appBarHeight - 12,
  },
  linkContainer: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    color: "inherit",
    userSelect: "none",
  },
  linksDesktop: {
    position: "absolute",
    top: "50%",
    right: 24,
    transform: "translateY(-50%)",
    "& a:hover": {
      textDecoration: "underline !important",
    },
  },
  appBarMenu: {
    position: "absolute",
    top: "50%",
    right: 0,
    transform: "translateY(-50%)",
    color: "#ffffff",
  },
  backdrop1: {
    backgroundImage: "url('/images/background-tile.png')",
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
    width: "100%",
    zIndex: -1,
  },
  backdrop2: {
    backgroundColor: "rgba(255, 255, 255, .35)",
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
    width: "100%",
    zIndex: -1,
  },
}));

export default () => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const currentTheme = useTheme();
  const isMobile = useMediaQuery(currentTheme.breakpoints.down("md"));

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const items = [
    {
      text: "Home",
      url: "/",
    },
    {
      text: "Evaluation",
      url: "/evaluate",
    },
    {
      text: "Turnaround Times",
      url: "/turnaround-times",
    },
    {
      text: "Start Submission",
      url: "/order",
    },
    {
      text: "Gallery",
      url: "/gallery",
    },
  ];

  useEffect(() => {
    if (!isMobile && anchorEl) {
      setAnchorEl(null);
    }
  }, [isMobile, anchorEl]);

  return (
    <>
      <div className={classes.backdrop1} />
      <div className={classes.backdrop2} />
      <BrowserRouter>
        <AppBar className={classes.appBar}>
          <div className={classes.linkContainer}>
            {/* eslint-disable-next-line */}
            <img className={classes.appBarImage} src="/images/logo.jpg" />
            <Typography variant="h4" style={{ marginLeft: 10 }}>
              GM Subs
            </Typography>
          </div>
          <div>
            {isMobile ? (
              <>
                <Button className={classes.appBarMenu} onClick={handleClick}>
                  <MenuIcon color="inherit" />
                </Button>
                <Menu
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  {items.map((item) => (
                    <Link key={item.url} to={item.url} className={classes.link}>
                      <MenuItem onClick={handleClose}>{item.text}</MenuItem>
                    </Link>
                  ))}
                </Menu>
              </>
            ) : (
              <div
                className={classes.linksDesktop}
                style={{ flexGrow: 1, textAlign: "right" }}
              >
                {items.map((item) => (
                  <Typography
                    key={item.url}
                    component={Link}
                    to={item.url}
                    color="inherit"
                    className="link"
                    style={{
                      textDecoration: "none",
                      fontSize: 18,
                      paddingLeft: 0,
                      marginLeft: 12,
                    }}
                  >
                    {item.text}
                  </Typography>
                ))}
              </div>
            )}
          </div>
        </AppBar>
        <Body>
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/gallery" exact component={Gallery} />
            <Route path="/evaluate" exact component={Evaluate} />
            <Route path="/order" exact component={Order} />
            <Route path="/print" exact component={Print} />
            <Route path="/blob/:key" exact component={Blob} />
            <Route path="/turnaround-times" exact component={TurnAroundTimes} />
            <Route path="/paypal/:email/:total" exact component={PayPal} />
            <Route path="/terms" exact component={TermsAndConditions} />
            <Route>
              <Redirect to="/" />
            </Route>
          </Switch>
          <Vacation />
        </Body>
        <ScrollRestore />
      </BrowserRouter>
    </>
  );
};
